module.exports = __webpack_public_path__ + "08e000816008c80db3f19a4a11f783f0.fbx";